import GeneratedHttpThunk from 'utility/redux/generatedHttpThunk';

const CMMonthRangeHttpRequest = (() => {
  const apiName = 'cmMonthRange';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `filter/month-range`;
  return generatedHttpThunk.generatePortfolioThunk();
})();

export default CMMonthRangeHttpRequest;
